// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Brand_wrapper__xdV6e","logo":"Brand_logo__KaODm","name":"Brand_name__2RZSl"};